export default __webpack_public_path__ + "static/media/cadeaux-2.e056f91f.jpeg";